import { Reducer } from 'redux';
import { DuplicateSearchActionTypes } from './actions';

// Type-safe initialState!
const initialState = {
  results: []
};

type IDuplicateSearchStoreState = Readonly<typeof initialState>;

const reducer: Reducer<IDuplicateSearchStoreState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case DuplicateSearchActionTypes.DUPLICATE_SEARCH: {
      let _state = { ...state };
      _state = { ..._state, results: action.value };
      return _state;
    }
    case DuplicateSearchActionTypes.GET_IMAGE: {
    //   stuff
    }
    default: {
      return state;
    }
  }
};

export default reducer;
